import { z } from 'zod'

export const orgAgreementSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['intern', 'nr', 'eduOrgName', 'internship', 'supervisorStart', 'supervisorEnd'])
    .catch('intern'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type OrgAgreementSearch = z.infer<typeof orgAgreementSearchSchema>

export const defaultOrgAgreementSearch: OrgAgreementSearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'intern',
  direction: 'asc',
}
